import React, {FC} from 'react'
import {HotelStatusCounts, padCount} from './statusCounts'

// Rendered inside the accordion header next to the section title. Counts are scoped to the
// applied filters across the whole result set, not just the page on screen.
export const HotelStatusCounters: FC<{counts?: HotelStatusCounts}> = ({counts}) => {
  if (!counts) return null
  return (
    <span className='d-inline-flex flex-wrap gap-4 ms-4 fw-bold'>
      <span className={counts.confirmation_pending > 0 ? 'text-danger' : 'text-muted'}>
        Confirmation Pending - {padCount(counts.confirmation_pending)}
      </span>
      <span className={counts.payment_due > 0 ? 'text-danger' : 'text-muted'}>
        Payment Due - {padCount(counts.payment_due)}
      </span>
      {/* Only worth showing when there is something to fix. */}
      {counts.needs_review > 0 && (
        <span className='text-warning' title='Payment recorded in a currency that looks wrong'>
          Currency Review - {padCount(counts.needs_review)}
        </span>
      )}
    </span>
  )
}
